<template lang="pug">

  v-container(fluid :v-if="isTokenSet")
    Termos
    v-row(align="center" dense)
      h1(class="headline") {{ $t('dash.TITLE') }}

      div(class="flex-grow-1")

      v-col(class="ml-3" xs="3" sm="3" md="2" lg="2" xl="2")
        v-row
          v-select(v-model="periods" :items="period_filter" :label="$t('dash.PERIOD')" append-icon="mdi-calendar-blank" target="#" class="mr-3" v-on:changed="changePeriod")
          //v-overflow-btn(v-model="periods" dense :items="period_filter" :label="$t('dash.PERIOD')" prepend-icon="mdi-calendar-blank" target="#" class="mr-3" border="0" v-on:changed="changePeriod")

    v-row(class="mt-n6")
      // barra lateral
      v-col(cols="12" xs="12" sm="12" md="5" lg="5" xl="5")

        v-row
          v-col
            UsersOnlineList

        v-row
          v-col(cols="12")
            LastConnections

      // Centro
      v-col(cols="12" xs="12" sm="12" md="7" lg="7" xl="7")

        v-row
          v-col(cols="6")
            OnlineInfo
          v-col(cols="6")
            AdsInfo

        v-row
          v-col
            MultiAxisChart

        v-row
          v-col
            WeekDonutChart
</template>

<script>

import UsersOnlineList from '@/components/common/UsersOnlineList'
import LastConnections from '@/components/common/LastConnections'

import Termos from '@/components/common/Termos'
import MultiAxisChart from '@/components/common/MultiAxisChart'
import WeekDonutChart from '@/components/common/WeekDonutChart'
import UptimeInfo from '@/components/common/UptimeInfo'
import AdsInfo from '@/components/common/AdsInfo'
import OnlineInfo from '@/components/common/OnlineInfo'

import { mapActions } from 'vuex'
import { mapGetters } from 'vuex'

export default {
  data: function() {
        return {
          periods: { text: `${this.$t('dash.LAST30DAYS')}`, value: 30},
          period_filter: [
            { text: `${this.$t('dash.LAST30DAYS')}`, value: 30},
            { text: `${this.$t('dash.LAST60DAYS')}`, value: 60}
          ],
        }
      },

  components: {
    Termos,
    UsersOnlineList,
    LastConnections,
    MultiAxisChart,
    WeekDonutChart,
    UptimeInfo,
    AdsInfo,
    OnlineInfo
  },

  // -----------------------------------------------------------

  created () {
    this.getChartsFromHs()
  },

  methods:{
    ...mapGetters(['isTokenSet']),
    ...mapActions(['getCharts']),

    async getChartsFromHs(){
      // sempre vem com os ultimos 30 dias
      const endDate = new Date().toISOString()
      const startDate = new Date(new Date().getTime() - (30 * 60 * 60 * 1000 * 24)).toISOString()
      if(window.localStorage.getItem('selectedHotspot') != null){
        await this.getCharts({
          identity: window.localStorage.getItem('selectedHotspot').split('"').join(''),
          dateBetween: `${startDate},${endDate}`
        })
      }

    },

    async changePeriod(newPeriod){
      const endDate = new Date().toISOString()
      const startDate = new Date(new Date().getTime() - (newPeriod * 60 * 60 * 1000 * 24)).toISOString()

      if(window.localStorage.getItem('selectedHotspot') != null){
        await this.getCharts({
          identity: window.localStorage.getItem('selectedHotspot').split('"').join(''),
          dateBetween: `${startDate},${endDate}`
        })
      }
    }
  },
  computed: {

    selectedHs () {
      return this.$store.state.adminHotspots.selectedHotspot
    },

    // multiAxisChartData () {
    //     return this.$store.state.adminDash.multiAxisChart
    // }
  },

  watch: {
    selectedHs (newselectedHs) {
      if(newselectedHs != null){ this.getChartsFromHs() }
    },
    periods(newPeriod) {
      this.changePeriod(newPeriod)
    }
  }

  // -----------------------------------------------------------

}
</script>
